import clsx from "clsx";
import { useState } from "react";
import { keycloak } from "../../../../lib/keycloak";
import { UserPlusIcon } from "../../../../ui/icons/userPlus";
import Button from "../../../../ui/molecules/button";
import { CompanyDTO } from "../../companies/dto";
import { EditCompanyForm } from "../../companies/editCompany/form/editCompanyForm";
import { PersonDTO } from "../dto";
import { AssociateCompanyModal } from "./associateCompany";

interface Props {
    isInTargetList: boolean
    associateCompany: CompanyDTO | null | undefined
    handleClose: () => void
    person?: PersonDTO
}
export function PersonCompany(props: Props) {
    const { isInTargetList, associateCompany, handleClose, person } = props
    const [visible, setVisible] = useState(false);

    return (
        <div>
            <div
                className={clsx("flex items-center flex-col justify-center p-6", {
                    hidden: associateCompany !== null
                })}
            >
                <span className="text-text-sm text-neutral-800">
                    Non è stata trovata nessuna azienda associata al contatto.
                </span>
                <div className={clsx("py-6 justify-end items-center gap-2 flex w-full")}>
                    <Button
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"outline"}
                        color={"blue"}
                        label="Annulla"
                        onClick={() => handleClose()}
                    />
                    <Button
                        size={"sm"}
                        disabled={keycloak.hasRealmRole('customer') || keycloak.hasRealmRole('collaborator')}
                        iconPosition={"left"}
                        icon={<UserPlusIcon color={""} size={0} />}
                        variant={"solid"}
                        color={"blue"}
                        label="Associa azienda"
                        onClick={() => setVisible(true)}
                    />
                    <AssociateCompanyModal visible={visible} onClose={() => setVisible(false)} operation="associate" person={person} />
                </div>
            </div>
            <div
                className={clsx("flex items-end justify-end w-full pb-4", {
                    hidden: !associateCompany,
                })}
            >
                <EditCompanyForm handleClose={handleClose} isInTargetList={isInTargetList} company={associateCompany ?? undefined} />
            </div>
        </div>
    )
}